<template>
  <v-row dense>
    <v-col cols="12">
      <span class="font-weight-bold">担当: </span>
      <MarkTag :text="getContent.tutor" :match="getQuery" />
    </v-col>
    <v-col cols="12">
      <span class="font-weight-bold">授業日: </span>
      <MarkTag :text="`${getContent.date} ${getContent.lesson.start}〜${getContent.lesson.end}`" :match="getQuery" />
    </v-col>
    <v-col cols="12">
      <span class="font-weight-bold">時給発生時間: </span>
      <MarkTag :text="`${getContent.wage}時間`" :match="getQuery" />
    </v-col>
    <v-col cols="12">
      <span class="font-weight-bold">科目: </span>
      <MarkTag :text="getContent.subject" :match="getQuery" />
    </v-col>
    <v-col cols="12">
      <span class="font-weight-bold">授業内容: </span>
      <MarkTag :text="getContent.topic" :match="getQuery" />
    </v-col>
    <v-col cols="12" v-if="getContent.comment">
      <span class="font-weight-bold">担当者コメント </span>
      <br />
      <MarkTag :text="getContent.comment" :match="getQuery" />
    </v-col>
    <v-col cols="12">
      <span class="font-weight-bold">次回授業予定日 </span>
      <br />
      <MarkTag :text="`${getContent.reserve.status}${getContent.reserve.date ? `：${this.$moment(getContent.reserve.date).format('YYYY年MM月DD日')}` : ''}`" :match="getQuery" />
      <br />
      <MarkTag :text="`${getContent.reserve.start}${getContent.reserve.end}` ? `${getContent.reserve.start}〜${getContent.reserve.end}` : ''" :match="getQuery" />
    </v-col>
    <v-col cols="12" v-if="getContent.note">
      <span class="font-weight-bold">備考欄: </span>
      <MarkTag :text="getContent.note" :match="getQuery" />
    </v-col>
  </v-row>
</template>

<script>
import MarkTag from '@/components/tags/mark'
export default {
  name: 'postTutorLayout',
  props: [ 'item' ],
  components: {
    MarkTag
  },
  computed: {
    getQuery () {
      return this.$route.query && this.$route.query.query || ''
    },
    getContent () {
      return (this.$props.item && this.$props.item.content) ? Object.assign(JSON.parse(this.$props.item.content), {
        date: this.$props.item.date ? this.$moment(this.$props.item.date).format('YYYY年MM月DD日') : ''
      }) : ''
    }
  }
}
</script>